import { zhCharReg } from "./contants";
import { math } from "@/utils/math";

// 是否是移动端
export const IS_MOBILE =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

/**
 * 判断是否是微信浏览器
 * @returns {boolean}
 */
export const IS_WECHAT = /MicroMessenger/i.test(navigator.userAgent);

/**
 * 判断金额，最多保留两位小数
 * @param num
 * @returns
 */
export const isPrice = (num: string) => {
  return /^\d+(\.\d{1,2})?$/.test(num);
};

/**
 *
 * @param tell 判断手机号
 * @returns
 */
export const isTell = (tell: string) => {
  return /^[18]\d{10}$/.test(tell);
};

/**
 * 是否是预发环境
 */
export const isRelease = () => {
  import.meta.env.MODE === "release";
};

export const getUserBrowserType = () => {
  let ua = navigator.userAgent.toLocaleLowerCase();
  let browserType = null;
  if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
    browserType = "IE";
  } else if (ua.match(/firefox/) != null) {
    browserType = "firefox";
  } else if (ua.match(/ucbrowser/) != null) {
    browserType = "UC";
  } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
    browserType = "opera";
  } else if (ua.match(/bidubrowser/) != null) {
    browserType = "baidu";
  } else if (ua.match(/metasr/) != null) {
    browserType = "sougou";
  } else if (
    ua.match(/tencenttraveler/) != null ||
    ua.match(/qqbrowse/) != null
  ) {
    browserType = "QQ";
  } else if (ua.match(/maxthon/) != null) {
    browserType = "maxthon";
  } else if (ua.match(/chrome/) != null) {
    let is360 = false;
    for (let key in navigator.plugins) {
      if (
        navigator.plugins[key].filename == "internal-nacl-plugin" ||
        navigator.plugins[key].filename == "np360SoftMgr.dll"
      ) {
        is360 = true;
      }
    }
    //   _mime("type", "application/vnd.chromium.remoting-viewer");
    if (is360) {
      browserType = "360";
    } else {
      browserType = "chrome";
    }
  } else if (ua.match(/safari/) != null) {
    browserType = "Safari";
  } else {
    browserType = "others";
  }
  return browserType;
};

/**
 * 兼容跳转
 * @param url
 */
export const goHref = (url) => {
  const ua = navigator.userAgent;
  if (ua.indexOf("Firefox") > -1) {
    setTimeout(() => {
      window.open(url, "_blank", "noopener, noreferrer");
    }, 100);
    return;
  }
  const aDom = document.createElement("a");
  aDom.target = "_blank";
  aDom.href = url;
  //   aDom.click();
  // 将锚点元素添加到文档中
  document.body.appendChild(aDom);

  // 创建一个用户交互事件
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });

  // 触发点击事件
  aDom.dispatchEvent(event);

  // 移除锚点元素
  document.body.removeChild(aDom);
};

/**
 * 兼容跳转
 * @param url
 */
export const goH5PayHref = (url, target = "_blank") => {
  const ua = navigator.userAgent;
  if (ua.indexOf("Firefox") > -1) {
    location.href = url;
    return;
  }
  setTimeout(() => {
    // 如果打开失败，通过location跳转 兼容 iphone12的safari
    if (document.visibilityState === "visible") location.href = url;
  }, 2000);

  const aDom = document.createElement("a");
  aDom.href = url;
  aDom.target = target;

  //   aDom.click();
  // 将锚点元素添加到文档中
  document.body.appendChild(aDom);

  // 创建一个用户交互事件
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });

  window.open(url, "_blank");
  // 触发点击事件
  aDom.dispatchEvent(event);
  // 移除锚点元素
  document.body.removeChild(aDom);
};

// export const getOrderTypeByUrl = () => {
//   const map = new Map([
//     ["pay", 1],
//     ["meeting", 2],
//     ["ppv", 3],
//     ["book", 4],
//   ]);
//   const path = location.pathname.substring(1);
//   return map.get(path) as OrderType;
// };

export const toLogin = () => {
  window.location.href = `/login?goto=${encodeURIComponent(
    `${location.pathname}${location.search}`
  )}`;
};

/**
 * 计算中英文字符
 * @param text
 * @returns
 */
export const calculateZhChar = (text: string) => {
  if (!text)
    return {
      count: 0,
      char: "",
    };
  let zhChar = "";
  let curMatch;
  while ((curMatch = zhCharReg.exec(text)) !== null) {
    zhChar += curMatch[0];
  }
  return {
    count: zhChar.length,
    char: zhChar,
  };
};

/**
 * 稿费计算公式
 * @param money
 */
export const computedArticleTaxMoney = (money: number = 0) => {
  let _money = math.divide(money, 1.09);
  // pod 税费
  return math.multiply(_money, 0.09);
};
